import { Component, Input, OnChanges, SimpleChanges, ViewChild } from "@angular/core";
import { MaintenanceHistoryService } from "@services";
import { IMaintenanceReadingModel, IDosageModel } from "@models";
import { ReadingsAndDosagesDialogComponent } from "../../app/appointments/components/readings-and-dosages-dialog/readings-and-dosages-dialog.component";

@Component({
	selector: "assets-readings-and-dosages",
	templateUrl: "./assets-readings-and-dosages.component.html",
	providers: [MaintenanceHistoryService]
})
export class AssetsReadingsAndDosagesComponent implements OnChanges {
	@Input() customerId: number;
	// 0 is the "Unassigned" bucket - readings and dosages taken before this customer had assets, and
	// anything left behind by a deleted one. Read-only: there is no live asset to record against.
	@Input() structureId: number;

	@ViewChild("readingsAndDosagesDialogRef") readingsAndDosagesDialogRef: ReadingsAndDosagesDialogComponent;

	isLoading = false;
	readings: IMaintenanceReadingModel[] = [];
	dosages: IDosageModel[] = [];

	constructor(private readonly maintenanceHistoryService: MaintenanceHistoryService) { }

	async ngOnChanges(changes: SimpleChanges) {
		if (changes.customerId || changes.structureId)
			await this.refresh();
	}

	get isUnassigned(): boolean {
		return !this.structureId;
	}

	async refresh() {
		if (!this.customerId)
			return;

		this.isLoading = true;

		try {
			const summary = await this.maintenanceHistoryService.getMaintenanceSummary(this.customerId, this.structureId ?? 0);
			this.readings = summary.maintenanceReadings || [];
			this.dosages = summary.dosages || [];
		}
		finally {
			this.isLoading = false;
		}
	}

	openDialog() {
		this.readingsAndDosagesDialogRef.openDialog(this.customerId, null, this.structureId);
	}
}
